import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import { ValidationAlert } from "../../components/common/ValidationAlert";
import Layout from "../../components/layout/Layout";
import useAlert from "../../hooks/useAlert";
import { initJsonClientTask, initJsonCompetitorTask } from "../../services/aws/ecs";
import { getCompanyNamesCompJson } from "../../services/gsuite/sheets";
import Clients from "./components/Clients";
import Competitors from "./components/Competitors";
import { validateInputsClient, validateInputsCompetitor } from "./utils/validation";

function ExportJson() {
  const [clientData, setClientData] = useState({
    quarter: null,
    year: null,
    company: null,
  });
  const [competitorData, setCompetitorData] = useState({
    company: null,
  });
  const { alertState, showAlert, closeAlert } = useAlert();
  const [companyNames, setCompanyNames] = useState([]);

  const handleClientDataChange = (newClientData) => setClientData(newClientData);
  const handleCompetitorDataChange = (newCompetitorData) => setCompetitorData(newCompetitorData);

  const handleSubmitCompetitor = async () => {
    if (!validateInputsCompetitor(competitorData, companyNames, showAlert)) return;
    showAlert(
      "info",
      "Waiting for NAT Gateway to be ready. Your task will be submitted shortly, please do not leave this page. The page will refresh after the task has been submitted."
    );

    const res = await initJsonCompetitorTask(competitorData.company);
    if (res.status === 200) {
      showAlert("success", "Successfully Submitted Task!");
      setTimeout(() => document.location.reload(), 2000);
    }
  };

  const handleSubmitClient = async () => {
    if (!validateInputsClient(clientData, companyNames, showAlert)) return;
    showAlert(
      "info",
      "Waiting for NAT Gateway to be ready. Your task will be submitted shortly, please do not leave this page. The page will refresh after the task has been submitted."
    );

    const res = await initJsonClientTask(clientData.company, clientData.year, clientData.quarter);
    if (res.status === 200) {
      showAlert("success", "Successfully Submitted Task!");
      setTimeout(() => document.location.reload(), 2000);
    }
  };

  const fetchCompanyNames = async () => {
    const companyNamesRes = await getCompanyNamesCompJson();
    const companyNamesJson = await companyNamesRes.json();
    setCompanyNames(companyNamesJson.company_names.sort());
  };

  useEffect(() => {
    fetchCompanyNames();
  }, []);

  return (
    <Layout>
      <ValidationAlert
        inputOpen={alertState.alertOpen}
        setInputOpen={closeAlert}
        severity={alertState.alertType}
        alertMessage={alertState.alertMsg}
      />

      <Grid container direction="row" sx={{ maxWidth: "100%" }}>
        <Grid size={6}>
          <Competitors
            companyNames={companyNames}
            competitorData={competitorData}
            onChangeState={handleCompetitorDataChange}
            onSubmit={handleSubmitCompetitor}
          />
        </Grid>
        <Grid size={6}>
          <Clients
            companyNames={companyNames}
            clientData={clientData}
            onChangeState={handleClientDataChange}
            onSubmit={handleSubmitClient}
          />
        </Grid>
      </Grid>
    </Layout>
  );
}

export default ExportJson;
